import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

import './font/Lato-Italic.ttf';
import './font/Lato-LightItalic.ttf';
import './font/Lato-Regular.ttf';
import './font/Lato-Light.ttf';
import './font/Lato-Thin.ttf';
import './font/Lato-ThinItalic.ttf';
import './font/Lato-Bold.ttf';
import './font/Lato-BoldItalic.ttf';
import './font/Lato-Black.ttf';
import './font/Lato-BlackItalic.ttf';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
